(function() {
  var slice = [].slice,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.register = function(module) {
    return module.factory('Core.Services.Steps', [
      '$state', function() {
        var args;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        return {
          "new": function() {
            return (function(func, args, ctor) {
              ctor.prototype = func.prototype;
              var child = new ctor, result = func.apply(child, args);
              return Object(result) === result ? result : child;
            })(exports.Steps, args, function(){});
          }
        };
      }
    ]);
  };

  exports.Steps = (function() {
    function Steps(state) {
      this.gotoStep = bind(this.gotoStep, this);
      this.getStepAt = bind(this.getStepAt, this);
      this._stepTitle = bind(this._stepTitle, this);
      this._findStepIndex = bind(this._findStepIndex, this);
      this._findStep = bind(this._findStep, this);
      this.gotoPrevStep = bind(this.gotoPrevStep, this);
      this.gotoNextStep = bind(this.gotoNextStep, this);
      this.enableStep = bind(this.enableStep, this);
      this.disableStep = bind(this.disableStep, this);
      this.setExitCallback = bind(this.setExitCallback, this);
      this.destroy = bind(this.destroy, this);
      this.fire = bind(this.fire, this);
      this.on = bind(this.on, this);
      this.once = bind(this.once, this);
      this.steps = [];
      this.state = state;
      this.activeStep = null;
      this.eventPrefix = null;
      this.callbacks = [];
    }

    Steps.prototype.once = function(eventname, stepname, cb) {
      return this.callbacks.push({
        name: eventname + ":" + stepname,
        callback: cb,
        once: true
      });
    };

    Steps.prototype.on = function(eventname, stepname, cb) {
      return this.callbacks.push({
        name: eventname + ":" + stepname,
        callback: cb,
        once: false
      });
    };

    Steps.prototype.fire = function(event, data) {
      var i, len, m, matches, results;
      matches = _.filter(this.callbacks, {
        name: event
      });
      results = [];
      for (i = 0, len = matches.length; i < len; i++) {
        m = matches[i];
        if (m.once) {
          _.remove(this.callbacks, m);
        }
        results.push(m.callback(data, event));
      }
      return results;
    };

    Steps.prototype.destroy = function() {
      if (this.activeStep != null) {
        return this.fire("switch-from:" + (this._stepTitle(this.activeStep)), {
          is_forward: true
        });
      }
    };

    Steps.prototype.setScope = function(scope) {
      return this.scope = scope;
    };

    Steps.prototype.setEventPrefix = function(prefix) {
      return this.eventPrefix = prefix;
    };

    Steps.prototype.setSteps = function(steplist) {
      return this.steps = steplist;
    };

    Steps.prototype.setExitCallback = function(cb) {
      return this.exitProcess = cb;
    };

    Steps.prototype.disableStep = function(name) {
      var id;
      id = this._findStepIndex(name);
      return this.steps[id].disabled = true;
    };

    Steps.prototype.enableStep = function(name) {
      var id;
      id = this._findStepIndex(name);
      return this.steps[id].disabled = false;
    };

    Steps.prototype.gotoNextStep = function() {
      var next, ref;
      next = this._findStep((ref = this.activeStep.name) != null ? ref : this.activeStep.state);
      if (this.scope && this.eventPrefix) {
        this.scope.$broadcast(this.eventPrefix + ":steps-next");
      }
      return this.gotoStep(this.steps[next], true);
    };

    Steps.prototype.gotoPrevStep = function() {
      var prev, ref;
      prev = this._findStep((ref = this.activeStep.name) != null ? ref : this.activeStep.state, false);
      if (prev < 0) {
        return this.exitProcess();
      } else {
        if (this.scope && this.eventPrefix) {
          this.scope.$broadcast(this.eventPrefix + ":steps-prev");
        }
        return this.gotoStep(this.steps[prev], false);
      }
    };

    Steps.prototype._findStep = function(name, next) {
      var currid, i, ind, len, step, steps;
      if (next == null) {
        next = true;
      }
      currid = this._findStepIndex(name);
      if (next) {
        steps = this.steps;
      } else {
        steps = this.steps.slice().reverse();
        currid = steps.length - currid - 1;
      }
      for (ind = i = 0, len = steps.length; i < len; ind = ++i) {
        step = steps[ind];
        if (ind > currid) {
          if (!step.disabled) {
            if (!next) {
              return steps.length - ind - 1;
            }
            return ind;
          }
        }
      }
      return -1;
    };

    Steps.prototype._findStepIndex = function(name) {
      var i, ind, len, ref, step;
      ref = this.steps;
      for (ind = i = 0, len = ref.length; i < len; ind = ++i) {
        step = ref[ind];
        if (step.name === name || (!step.name && step.state === name)) {
          return ind;
          break;
        }
      }
    };

    Steps.prototype._stepTitle = function(step) {
      var ref;
      return (ref = step.name) != null ? ref : step.state;
    };

    Steps.prototype.getStepAt = function(index) {
      return this.steps[index];
    };

    Steps.prototype.gotoStep = function(step, is_forward) {
      if (step && ((step != null ? step.state : void 0) == null)) {
        step = this.steps[this._findStepIndex(step)];
      }
      if (step == null) {
        return;
      }
      if (this.activeStep != null) {
        this.activeStep.active = false;
        this.fire("switch-from:" + (this._stepTitle(this.activeStep)), {
          is_forward: is_forward
        });
      }
      this.activeStep = step;
      step.active = true;
      step.visited = true;
      if (this.state.$current.toString() !== step.state) {
        this.state.go(step.state);
      }
      if (step.fullpage && this.scope) {
        this.scope.show_fullpage = true;
      } else {
        this.scope.show_fullpage = false;
      }
      return this.fire("switch-to:" + (this._stepTitle(this.activeStep)), {
        is_forward: is_forward
      });
    };

    return Steps;

  })();

}).call(this);
